import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import api from "axios.config";

import {
  GetGroupByIdWareHouseSuccess,
  GetGroupWareHouseSuccess,
  WareHousesGroupByIdParams,
} from "./wareHouses.type";

export const useGetWareHousesInit = () => {
  return useQuery<GetGroupWareHouseSuccess, AxiosError<GlobalErrorResponse>>({
    queryKey: ["b2bapp-group-ware-houses"],
    queryFn: async ({ signal }) =>
      api
        .get(`${process.env.REACT_APP_B2BAPP_GROUP_WAREHOUSES}`, {
          signal,
        })
        .then((r) => r.data),
  });
};

export const useActiveGroupById = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: GetGroupByIdWareHouseSuccess) => void;
  onError: (error: AxiosError<GlobalErrorResponse>) => void;
}) => {
  return useMutation<
    GetGroupByIdWareHouseSuccess,
    AxiosError<GlobalErrorResponse>,
    WareHousesGroupByIdParams
  >({
    mutationFn: async (data) => {
      return api
        .post(`${process.env.REACT_APP_B2BAPP_GROUP_ID_ACTIVE}/${data?.id}`)
        .then((r) => r.data);
    },
    onSuccess,
    onError,
  });
};
